<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>문제해결</p>
                <ChevronRight :size="24"></ChevronRight>
                <p>솔루션</p>
            </div>
        </div>

        <div id="product-select" class="column screen-width">
            <p style="font-size: 32px; font-weight: bold">{{ title }}</p>
            <ul class="row" style="gap: 80px">
                <li>
                    <span
                        style="
                            padding-right: 20px;
                            border-right: 1px solid gray;
                        "
                        >날짜</span
                    >
                    <span style="padding-left: 20px">{{ date }}</span>
                </li>
                <li>
                    <span
                        style="
                            padding-right: 20px;
                            border-right: 1px solid gray;
                        "
                        >조회수</span
                    >
                    <span style="padding-left: 20px">{{ viewCount }}</span>
                </li>
            </ul>

            <div style="width: 100%; height: 2px; background: black"></div>
        </div>

        <div id="solution" class="screen-width" v-html="safeHtml"></div>
        <div 
            class="screen-width" 
            style="
                display: flex;
                justify-content: end;
                margin-bottom: 40px;
            "
        >
            <button
                style="
                    width: 120px;
                    height: 60px;
                    border-radius: 10px;
                    background: #474747;
                "
                @click="goBack"
            >
                <p style="color: white; font-weight: bold">뒤로</p>
            </button>
        </div>
    </v-container>
</template>

<script>
import { ref, onMounted, computed, onUpdated } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import TextButton from "@/components/TextButton.vue";
import SearchBar from "@/components/SearchBar.vue";
import PostListItem from "@/components/PostListItem.vue";
import CustomPagination from "@/components/CustomPagination.vue";
import DOMPurify from "dompurify";

export default {
    name: "problem-layout",
    props: ["id"],
    components: {
        HomeOutline,
        ChevronRight,
        TextButton,
        SearchBar,
        PostListItem,
        CustomPagination,
    },
    setup(props) {
        const store = useStore();
        const router = useRouter();
        const solution = ref(null);
        const title = ref("");
        const date = ref("");
        const viewCount = ref("");

        onUpdated(() => {
            // alert("hi");
        });

        onMounted(() => {
            store.dispatch("getSolution", props.id).then((res) => {
                solution.value = res;
                title.value = res.title;
                date.value = formatKoreanDate(res.createdAt);
                postContent.value = res.detail;
                viewCount.value = res.viewCount;
            });
        });
        const postContent = ref("");

        const safeHtml = computed(() => {
            return DOMPurify.sanitize(postContent.value, {
                ADD_TAGS: ["iframe"], // iframe 태그 추가
            });
        });

        const formatKoreanDate = (dateString) => {
            const date = new Date(dateString);
            return date
                .toLocaleDateString("ko-KR", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                })
                .replace(/\. /g, "-")
                .slice(0, -1); // 한국 형식은 보통 "YYYY. MM. DD." 이므로 이를 변환합니다.
        };

        const goBack = () => {
            router.back();
        }


        return {
            safeHtml,
            postContent,
            solution,
            title,
            date,
            formatKoreanDate,
            viewCount,
            goBack
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

#product-select {
    padding: 40px 0px;
    gap: 24px;
}

#product-list {
    width: 85%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
}

ul {
    list-style-type: none;
    list-style: none;
}

#solution {
}
</style>
